import { connect } from 'react-redux';
import Comments from '../../components/comments/comments';

import { removeComment } from '../../actions/comments';
import { seek } from '../../actions/player';
import { showMoreComments, finishGoToComment, showCommentMenu, startCommentReply, startEditingComment } from '../../actions/ui';

const mapStateToProps = function(state) {
	return {
		comments: state.comments,
		features: state.features,
		selected_type: state.ui.comment_type || "",
		user: state.user,
		source: state.ui.source,
		visible_comments: state.ui.visible_comments,
		highlighted_comment: state.ui.highlighted_comment,
		scroll_to_comment: state.ui.scroll_to_comment,
		show_comment_menu: state.ui.show_comment_menu
	};
}

const mapDispatchToProps = function(dispatch) {
	return {
		showMoreComments: ()=>dispatch(showMoreComments()),
		finishGoToComment: ()=>dispatch(finishGoToComment()),
		seek: (timestamp)=>dispatch(seek(timestamp)),
		showCommentMenu: (objectid)=>dispatch(showCommentMenu(objectid)),
		removeComment: (objectid)=>dispatch(removeComment(objectid)),
		startCommentReply: (objectid)=>dispatch(startCommentReply(objectid)),
		startEditingComment: (objectid)=>dispatch(startEditingComment(objectid))
	};
}

const CommentsContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
	undefined,
	{
		pure: true
	}
)(Comments)

export default CommentsContainer;